// https://www.digitalocean.com/community/tutorials/how-to-add-login-authentication-to-react-applications
// https://wordpress.stackexchange.com/questions/311825/how-to-login-via-wordpress-api-and-get-user-details

import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import useToken from '../../hooks/useToken.js'
import useCart from '../../hooks/useCart.js'
import { MainContext } from '../../contexts/MainContext'
import { fetchCurrentUser, fetchCurrentUserData, authorizeUser, fetchCurrentUserNonce } from '../../fetch/WPAPI'

async function loginUser(credentials) {
  return await authorizeUser(credentials.email, credentials.password)
}

const LoginForm = (props) => {
  const { token, setToken, nonce, setNonce } = useToken()
  const { setCart } = useCart()
  const navigate = useNavigate()
  const mainContext = useContext(MainContext)
  
  useEffect(() => {
    if (token && token.token) {
      setCart([])
      navigate('/me')
    }
  }, [])

  const [ email, setEmail ] = useState('')
  const [ password, setPassword ] = useState('')
  const [ loginFail, setLoginFail ] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    const result = await loginUser({
      email,
      password
    })
    if (result.data?.status == 403) {
      setLoginFail(true)
    } else {
      setToken(result)

      if (!mainContext.userData.id) {
        fetchCurrentUser(result.token)
          .then(result => {
            // console.log(result)
            if (result.id) {
              fetchCurrentUserData(result.id)
                .then(resultWoo => {
                  // console.log(resultWoo)
                  if (resultWoo.id) {
                    mainContext.setUserData(resultWoo)
                    mainContext.setUserWpData(result)
                    setCart([])
                    navigate('/me')
                  } else {
                    setToken(null)
                    setLoginFail(true)
                  }
                })
            } else {
              setToken(null)
              setLoginFail(true)
            }
          })
      }

      fetchCurrentUserNonce(result.token)
        .then(result => {
          // console.log(result)
          setNonce(result.nonce)
        })
    }
  }

  return <div className="af-class-log-in__form-block w-form">
    <form onSubmit={handleSubmit} id="wf-form-Log-in-form" className="af-class-log-in__form">
      { loginFail && <div style={{ color: 'red' }}>Неверная пара логин/пароль</div> }
      <div className="w-layout-grid af-class-log-in__form-grid">
        <input type="email" className="af-class-cart__user-field w-input" maxLength={256} placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <input type="password" className="af-class-cart__user-field w-input" maxLength={256} placeholder="Пароль" required value={password} onChange={(e) => setPassword(e.target.value)} />
        <a id="w-node-_28c615f2-5964-0115-9cb4-05aeb7d195d2-b23d362e" href="#" className="af-class-button--secondry w-inline-block" onClick={props.openRecoveryPopup}>
          <div className="af-class-cart__button--secondry__text">Забыли пароль?</div>
          <div className="af-class-cart__button--secondry__underline" />
        </a>
      </div>
      <input type="submit" value="Вход" className="af-class-button--primary af-class-log-in w-button" />
    </form>
  </div>
}

export default LoginForm